/* eslint-disable no-eval, react/no-direct-mutation-state */
import React from 'react';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { connect } from "react-redux";
import BiDynamicForm from '../../../partials/layout/BiDynamicForm';
import { ValidationSummary, ValidationGroup } from 'devextreme-react';
import { injectIntl } from "react-intl";
import TemplateHelper from '../../../Templates/TemplateHelper';
import { CheckBox } from 'devextreme-react/check-box';
import { Form, Item as FormItem, SimpleItem, RequiredRule, GroupItem, RangeRule } from 'devextreme-react/form';
import { typeOptions as actionTypes } from "../../admin/Contracts/Contract/ContractActions";
import ActionModalPostActions from "./ActionModalPostAction";
import Common from '../../../shared/common';
import moment from 'moment';

export const RESPONSE = {
    OK: 'OK',
    CANCEL: 'CANCEL',
    CUSTOM_BUTTON_CLICK: 'CUSTOM_BUTTON_CLICK'
};
const appcuesEnabled = process.env.REACT_APP_APPCUES_ENABLED === "true";
class ActionModal extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = React.createRef();
        this.formRef = React.createRef();
        this.validatorName = 'ReplyDraftModalValidator';
        this.state = {
            users: null,
            accountid: null,
            saveButtonEnabled: false,
            selectedPostActions: null
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.visible !== this.props.visible) {
            if (this.props.visible) {
                this.saved = false;
                if ((this.props.mode === 'REPLY_DRAFT' || this.props.mode === 'SAVE_DRAFT')) {
                    this.loadUsers();
                }
                else {
                    this.setState({ saveButtonEnabled: true });
                }
            }
            else {
                this.setState({ saveButtonEnabled: false });
            }

        }
    }
    loadUsers = () => {
        let filteredUsers = this.props.contractUsers;
        let logicExpression = null;
        //filter if userlimit is null or greater than the entered amount
        if (this.props.workflowItem.financialLimitEnabled && this.props.userLimit) {
            //#TODO: These users should be fetched from API
            filteredUsers = this.props.contractUsers.filter(user => this.props.contract.financiallimitenabled === 1 ? (!user.contractuserlimit && user.contractuserlimit !== 0) || user.contractuserlimit > this.props.userLimit : (!user.userlimit && user.userlimit !== 0) || user.userlimit > this.props.userLimit);

        }
        if (this.props.mode === 'REPLY_DRAFT') {
            //USERS WITH REPLY_SEND PREVILIGES
            let filterStr = this.props.workflowItem.userFilters.replyNotice.communicateReplyFilter;
            if (this.props.overrideReplyParty) {
                filterStr = TemplateHelper.GetDefaultFilter_OverrideCommunicateReplyFilter(this.props.overrideReplyPartyValue);
            }
            logicExpression = TemplateHelper.ConvertDxFilterExpToLogicExp(JSON.parse(filterStr), 'user');
        }
        else if (this.props.mode === 'SAVE_DRAFT') {
            //USERS WITH COMMUNICATE PREVILIGES
            logicExpression = TemplateHelper.ConvertDxFilterExpToLogicExp(JSON.parse(this.props.workflowItem.userFilters.mainNotice.communicateFilter), 'user');
        }

        //FILTER USERS DEPENDING ON DYNAMIC LOGIC EXPRESSION OF SETTING
        filteredUsers = filteredUsers.map(u => ({ party: u.usergroup, rolepermissions: u.rolepermissions, accountid: u.accountid, display: `${u.user} (${u.useremail})` }))
            .filter(user => eval(logicExpression));

        this.setState({ users: filteredUsers.sort((a, b) => a.display.localeCompare(b.display)), accountid: null, saveButtonEnabled: true });
    }
    onClose = (e) => {
        if (this.props.visible) {
            this.props.onDialogResult(RESPONSE.CANCEL);
        }
    }

    getPostActionSelections = () => {
        if (this.formRef.current?.instance) {
            const actionsFormObj = this.formRef.current.instance().option("formData");
            let selectedPostActions = [];

            let selectedOption = null;
            if (this.props.mode === 'COMMUNICATE') {
                selectedOption = this.props.selectedClause;
            }
            if (this.props.mode === 'REPLY_SEND') {
                selectedOption = this.props.selectedReply;
            }
            if (selectedOption?.postActions?.length > 0) {
                selectedPostActions = selectedOption.postActions.filter(act => (!!actionsFormObj[act.actionType] && act.action === "CREATE"));
                selectedPostActions = selectedPostActions.map(act => {
                    let daysForAction = 0;
                    let actionDateDisplay = null;
                    if ((act.timePeriod && act.timePeriod === "CUSTOM") || !act.timePeriod) {
                        daysForAction = act.daysForAction;
                    }
                    else if (act.timePeriod === "ASK_ON_FORM") {
                        actionDateDisplay = moment(actionsFormObj["DD_" + act.actionType]).format('DD/MM/YYYY');
                    }
                    else {
                        const { resources } = this.props.contractTemplate;
                        if (resources.hasOwnProperty(act.timePeriod)) {
                            if (typeof resources[act.timePeriod] === "number") {
                                daysForAction = resources[act.timePeriod];
                            }
                        }
                    }
                    let resolvingWorkflowID = null;
                    let actionType = act.actionType;
                    if (act.actionType.startsWith("WF_")) {
                        resolvingWorkflowID = Number(act.actionType.substring(3));
                        actionType = "COMMUNICATE_NOTICE";
                    }
                    return {
                        actionType: actionType,
                        resolvingWorkflowID,
                        ownerParty: act.ownerParty,
                        daysForAction,
                        actionDateDisplay
                    }
                })
                //!!!!!! NEED TO ADD resolvingworkflowid INTO OBJECT IF TYPE IS WF_XX
            }
            let selectedClearActions = Object.entries(actionsFormObj).filter(([k, v]) => k.startsWith("CLEAR_") && v === true).map(([k, v]) => Number(k.substring(6)));
            return { createactions: selectedPostActions, completeactions: selectedClearActions };
        }
    }
    saveItem = () => {
        if (this.formRef.current?.instance) {
            const validationRes = this.formRef.current.instance().validate();
            if (!validationRes.isValid) {
                return;
            }
        }

        let props;
        if (this.props.mode === 'REPLY_DRAFT' || this.props.mode === 'SAVE_DRAFT') {
            if (!this.validateForm()) {
                return;
            }
            props = { userid: this.state.accountid };
        }
        else {
            props = this.getPostActionSelections();
        }
        if (!this.saved) {
            this.saved = true;
            this.triggerAppcuesEvent();
            this.setState({ saveButtonEnabled: false }, () => {
                this.props.onDialogResult(RESPONSE.OK, props);
            });
        }
    }
    triggerAppcuesEvent = () => {
        if (appcuesEnabled && window.Appcues) {
            window.Appcues.track("ACTION_" + this.props.mode, {
                workflowid: this.props.workflowItem.id
            });
        }
    }
    groupCaptionNamedRender = (caption, iconName) => {
        return (
            <React.Fragment>
                <i className={`dx-icon dx-icon-${iconName}`}></i>
                <span>{caption}</span>
            </React.Fragment>
        )
    };
    secondaryButtonClicked = () => {
        let props;
        if (this.props.mode === 'COMMUNICATE') {
            props = this.getPostActionSelections();
        }
        if (this.props.mode === 'SAVE_DRAFT' || this.props.mode === 'REPLY_DRAFT') {
            this.props.onDialogResult(RESPONSE.OK);
        } else if (this.props.mode === 'REPLY_SEND' && this.props.customButtonEnabled) {
            this.props.onDialogResult(RESPONSE.CREATE, props);
        }
        else {
            this.props.onDialogResult(RESPONSE.CANCEL);
        }
    }
    validateForm = () => {
        const validationResult = this.validatorRef.current.instance().validate();
        return validationResult.isValid;
    }
    onValueChanged = (field, value) => {
        if (field === 'user') {
            this.state.accountid = value;
        }
    }
    generateForm = () => {
        if (this.props.mode === 'REPLY_DRAFT' || this.props.mode === 'SAVE_DRAFT') {
            const userConfig = {
                fields: [
                    { resource: "GENERAL.WARNING.SELECT_NOTIFY_USER", dataField: 'user', editorType: 'dxSelectBox', editorOptions: { dataSource: this.state.users, valueExpr: 'accountid', displayExpr: 'display' } },
                ]
            };
            return (
                <ValidationGroup ref={this.validatorRef} name={this.validatorName}>
                    <BiDynamicForm
                        config={userConfig}
                        valueChangeHandler={this.onValueChanged}
                    />
                    <div>
                        <ValidationSummary elementAttr={{ align: "right", paddingBottom: 50 }} id={this.validatorName}></ValidationSummary>
                    </div>
                </ValidationGroup>
            )
        }
        //&& !this.props.workflowItem.replyEnabled)
        if (this.props.mode === 'COMMUNICATE' || this.props.mode === 'REPLY_SEND') {
            return (
                <ValidationGroup ref={this.validatorRef} name={this.validatorName}>
                    <ActionModalPostActions
                        {...this.props}
                        formRef={this.formRef}
                    />
                    <div>
                        <ValidationSummary elementAttr={{ align: "right", paddingBottom: 50 }} id={this.validatorName}></ValidationSummary>
                    </div>
                </ValidationGroup>
            )
        }

        else { return null; }
    }
    render() {

        let primaryButtonText;
        let primaryButtonStylingMode = "contained";
        let primaryButtonType = "success";;

        switch (this.props.mode) {
            case 'COMMUNICATE':
                primaryButtonText = this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_COMMUNICATE" });
                break;
            case 'DELETE_DRAFT':
                primaryButtonText = this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_DELETE" });
                primaryButtonStylingMode = "outlined";
                primaryButtonType = "danger";
                break;
            case 'REPLY_DRAFT':
                primaryButtonText = this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_SAVE_REPLY_DRAFT_NOTIFY" });
                break;
            case 'SAVE_DRAFT':
                primaryButtonText = this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_SAVE_AND_NOTIFY" });
                break;
            case 'REPLY_SEND':
                primaryButtonText = this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_SEND_REPLY" });
                break;
            default:
                primaryButtonText = this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_COMMUNICATE" });
                break;
        }

        return (

            <Popup
                visible={this.props.visible}
                onHiding={this.onClose}
                dragEnabled={true}
                hideOnOutsideClick={true}
                // showTitle={true}
                // title={this.props.title}
                width={600}
                height='auto'
                maxHeight={600}
                wrapperAttr={{ id: "ActionModal" }}
            // animation={{
            //     show: {
            //         type: "pop", 
            //         duration: 50, 
            //         from: { scale: 0.75 } ,
            //         to: { scale: 1 }
            //         // type: "fade",
            //         // from: 0,
            //         // to: 1,
            //     },
            //     // hide : { type: 'slide', duration: 400, from: { position: { my: 'center', at: 'center', of: window } }, to: { position: { my: 'top', at: 'bottom', of: window } }}
            //     hide: {
            //         type: "pop",
            //         duration: 400,
            //         from: { scale: 1 } ,
            //         to: { scale: 0.55 }
            //     }
            // }
            // }
            >
                <div>
                    <p>
                        <span>{this.props.text}</span>
                    </p>
                    {this.props.visible && (
                        this.generateForm()
                    )
                    }
                </div>
                <ToolbarItem location="before"
                    locateInMenu="never"
                    template={`<div style=\"font-size: 20px;\">${this.props.title}</div>`}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                        onClick: () => { this.props.onDialogResult(RESPONSE.CANCEL) },
                        stylingMode: "outlined",
                        type: "normal",
                        elementAttr: { id: "ActionModalCancelButton" }
                    }}>
                </ToolbarItem>
                {this.props.customButtonEnabled && (
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{
                            text: this.props.customButtonLabel,
                            onClick: () => { this.props.onDialogResult(RESPONSE.CUSTOM_BUTTON_CLICK); },
                            stylingMode: "outlined",
                            type: "success",
                            elementAttr: { id: "ActionModalSecondaryButton" }
                        }}>
                    </ToolbarItem>
                )}
                {(this.props.mode === 'SAVE_DRAFT' || this.props.mode === 'REPLY_DRAFT') && (
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{
                            text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_ONLY_SAVE" }),
                            onClick: () => { this.props.onDialogResult(RESPONSE.OK); },
                            stylingMode: "outlined",
                            type: "success",
                            elementAttr: { id: "ActionModalSaveOnly" }
                        }}>
                    </ToolbarItem>
                )}
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: primaryButtonText,
                        disabled: !this.state.saveButtonEnabled,
                        stylingMode: primaryButtonStylingMode,
                        type: primaryButtonType,
                        ...this.props.buttonOptions,
                        onClick: this.saveItem,
                        elementAttr: { id: "ActionModalPrimaryButton" }
                    }}>
                </ToolbarItem>
            </Popup>
        );
    }
}

const mapStateToProps = store => ({
    contractTemplate: store.contract.template,
    contractUsers: store.contract.users,
    contract: store.contract.contract
});


export default injectIntl(connect(mapStateToProps)(ActionModal));